/* eslint-disable react-hooks/exhaustive-deps */
import { fetchPhpEigth } from 'api';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import { SimpleWrapper } from 'components/InputsMex/containers';
import Page from 'components/Page';
import { SeleccionarFecha } from 'containers/Pymes/componentes/entradas';
import { BaseButton } from 'containers/Pymes/emision/EmisionFooterBarButtons';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import COLORS from 'utils/constants/COLORS';
import { guardarTracking } from 'utils/tracking';
import Loading from 'wrappers/Loading';
import { CASUALITY_GENERAL } from '../constantes';

export const VigenciaCasualityGenerales = () => {
    const { id = '' } = useQueryParams();
    const { addWarningToast } = useCustomToast();
    const history = useHistory();
    const [loading, setLoading] = useState(true);

    const [fechaInicio, setFechaInicio] = useState();
    const [fechaFin, setFechaFin] = useState();
    const [fechaSelected, setFechaSelected] = useState(null);

    const methods = useForm({ mode: 'onChange' });
    const { handleSubmit } = methods;
    const solicitarRangoVigencia = async () => {
        setLoading(true);
        const Data = { idPoliza: id };

        const respRangosVigencia = await fetchPhpEigth(
            CASUALITY_GENERAL.endpoints.generarVigencia,
            Data,
        );

        if (respRangosVigencia?.transaccion === true) {
            guardarTracking(CASUALITY_GENERAL.endpoints.guardarTracking, id || '', 'Carga catalogo vigencia', 'Cargar catalogo', window.location.href)
            setFechaInicio(respRangosVigencia?.fechaInicio);
            setFechaFin(respRangosVigencia?.fechaFin);
            if (
                respRangosVigencia?.fechaInicioVigencia &&
                respRangosVigencia?.fechaInicioVigencia !== ''
            ) {
                setFechaSelected(respRangosVigencia?.fechaInicioVigencia + ' 12:00:00');
                methods.reset({
                    fechaInicioVigencia: moment(
                        respRangosVigencia?.fechaInicioVigencia,
                    ).toDate(),
                });
            }
        }
        setLoading(false);
        return respRangosVigencia;
    };
    useEffect(() => {
        solicitarRangoVigencia();
    }, []);

    const onSubmit = async (data) => {
        setLoading(true);
        const Data = {
            ...data,
            idPoliza: id,
            fechaInicioVigencia: moment(data?.fechaInicioVigencia).format('yyyy-MM-DD'),
        };

        const respuestaGuardar = await fetchPhpEigth(
            CASUALITY_GENERAL.endpoints.guardarVigencia,
            Data,
        );
        if (respuestaGuardar?.transaccion === true) {
            history.push(`${CASUALITY_GENERAL.urls.pago}?id=${id || ""}`);
        } else {
            if (respuestaGuardar?.msgError) {
                addWarningToast(respuestaGuardar?.msgError, { autoDismiss: false });
            }
        }
        setLoading(false);
    };

    const onSubmitError = (error) => {
        console.error(error);
    };

    const onClickSiguiente = () => {
        guardarTracking(CASUALITY_GENERAL.endpoints.guardarTracking, id || '', "Click continuar en pantalla vigencia", 'Guardar vigencia', window.location.href);
        handleSubmit(onSubmit, onSubmitError)();
    };

    const regresar = () => {
        guardarTracking(
            CASUALITY_GENERAL.endpoints.guardarTracking,
            id || "",
            "Click atrás pantalla 5 Casuality",
            "Regresar pantalla 5",
            window.location.href
        );
        history.push(`${CASUALITY_GENERAL.urls.contratante}?id=${id || ""}`);
    };
    return (
        <Loading loading={loading}>
            <div className="cr-content">
                <Page>
                    <BreadCurmb {...PASOS_BREADCRUMBS[CASUALITY_GENERAL.codProducto].breadCrumb} />
                    <BreadCrumbPasosV2
                        {...PASOS_BREADCRUMBS[CASUALITY_GENERAL.codProducto].breadCrumbPasosCotizacion[5]}
                        styleimg='height200px mr-3'
                        pasos={PASOS_BREADCRUMBS[CASUALITY_GENERAL.codProducto]?.pasosCotizacion}
                    />
                    <div className="row justify-content-center">
                        <div className="col-md-10 card-login-mex py-5 text-center">
                            <h1 className="display-4 font-mex">Vigencia de la póliza</h1>

                            <div className="row d-flex justify-content-center">
                                <div className="col-md-6 col-lg-5 col-12">
                                    <FormProvider {...methods}>
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <SimpleWrapper
                                                name="fechaInicioVigencia"
                                                label="Por favor, seleccione la vigencia de la póliza"
                                            >
                                                <SeleccionarFecha
                                                    name="fechaInicioVigencia"
                                                    fechaInicio={fechaInicio}
                                                    fechaFin={fechaFin}
                                                    preload={fechaSelected}
                                                    rules={{ required: 'Por favor seleccione una fecha' }}
                                                />
                                            </SimpleWrapper>
                                        </form>
                                    </FormProvider>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-11">
                            <div className="row justify-content-center">
                                <div className="col-11 col-md-4 col-lg-3">
                                    <BaseButton
                                        onClick={() => {
                                            regresar();
                                        }}
                                        type="button"
                                        textColor="white"
                                        bgColor={COLORS.primary}
                                    >
                                        <i
                                            className="pi pi-arrow-left"
                                            style={{
                                                position: 'relative',
                                                top: '1px',
                                                fontSize: '1.4rem',
                                            }}
                                        />{' '}
                                        Atrás
                                    </BaseButton>
                                </div>
                                <div className="col-11 col-md-4 col-lg-3">
                                    <BaseButton
                                        textColor="white"
                                        // type="submit"
                                        bgColor={COLORS.primary}
                                        onClick={onClickSiguiente}
                                    >
                                        Continuar{' '}
                                        <i
                                            className="pi pi-arrow-right"
                                            style={{
                                                position: 'relative',
                                                top: '1px',
                                                fontSize: '1.4rem',
                                            }}
                                        />
                                    </BaseButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </Page>
            </div>
        </Loading>
    );
};
